import React from "react";

const ItensDividaAtivaCard = ({ itensDividaAtiva }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Situação do Contribuinte na Dívida Ativa</b>
      </div>
      <div className="card-body">
        <center>
          <table className="table table-striped table-bordered" width="100%">
            <thead>
              <tr>
                <th>
                  <center>Número da origem</center>
                </th>
                <th>
                  <center>Número do processo</center>
                </th>
                <th>
                  <center>Situação</center>
                </th>
                <th>
                  <center>Data do cadastro</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {itensDividaAtiva?.map((item) => (
                <tr>
                  <td align="right">{item.situacao}</td>
                  <td align="right">{item.numeroProcesso}</td>
                  <td>
                    <center>{item.numeroOrigem}</center>
                  </td>
                  <td>
                    <center>{item.dataCadastro}</center>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default ItensDividaAtivaCard;
